/**
 * AddNewConfirmRow — T23.
 *
 * The inline "Add new" option that appears at the bottom of LibraryCombobox
 * dropdowns when the typed value has no exact match in the library.
 *
 * Renders as a Combobox.Option with distinct styling (muted color when
 * disabled, primary color label when idle).
 */
import { Combobox, Text } from '@mantine/core';

interface AddNewConfirmRowProps {
  /** The typed display name to be added */
  typedValue: string;
  /** The library type label shown in the option text (e.g. "angle") */
  typeName: string;
  /** Unique value passed to Combobox.onOptionSubmit */
  optionValue: string;
  /** Whether the API call is in-flight (prevents double-submit) */
  disabled: boolean;
}

/**
 * Renders: `+ Add "<typedValue>" to <typeName> library`
 */
export function AddNewConfirmRow({
  typedValue,
  typeName,
  optionValue,
  disabled,
}: AddNewConfirmRowProps) {
  return (
    <Combobox.Option value={optionValue} disabled={disabled} data-testid="add-new-option">
      <Text size="sm" c={disabled ? 'dimmed' : 'blue'}>
        + Add &quot;{typedValue}&quot; to {typeName} library
      </Text>
    </Combobox.Option>
  );
}
